export default __webpack_public_path__ + "static/media/noise_high_light.35003c1e.svg";